<template>
  <div class="pa-5">
    <v-card shaped class="elevation-10">
      <v-card-title>{{ `แบบฟอร์ม${form_title}ข้อมูล` }}</v-card-title>
      <v-card-text class="pt-0">
        <editor v-model="form.content" :init="editor_config"/>
      </v-card-text>
      <v-card-actions class="d-flex flex-row justify-center">
        <v-btn color="success" @click="submit">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import tinymceConfig from './tinymce_config.js';

export default {
  components: {
		editor: Editor
  },
  data: () => ({
    editor_config: tinymceConfig,
    form: {
      id: '',
      content: ''
    }
  }),
  computed: {
    form_type() { return this.$route.meta.form_type },
    form_title() { return this.$route.meta.form_title },
    id() { return this.$route.params.id }
  },
  mounted() {
    if(this.form_type === 'EDIT') {
      this.$store.dispatch('about/edit', this.$route.params.id)
        .then(data => {
          this.form = {
            id: data.id,
            content: data.content
          }
        });
    }
  },
  methods: {
    submit() {
      this.$store.dispatch(`${this.form_type === 'CREATE' ? 'about/store' : 'about/update'}`, this.form).then(() => {
        this.$router.push({ name: 'AboutList' });
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: 'บันทึกข้อมูลสำเร็จ'
        });
      }).catch(() => {
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'error',
          message: 'เกิดข้อผิดพลาดบางอย่าง'
        });
      });
    }
  }
}
</script>

<style lang="scss">
  .cover-zone {
    border: 2px dashed;
    cursor: pointer;
  }
  .img-fluid {
    width: 100%;
  }
</style>